/* BulletedPointsList.tsx generated by @compiled/babel-plugin v0.29.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _11 = "._k48pni7l{font-weight:600}";
const _10 = "._18u0idpf{margin-left:0}";
const _9 = "._otyridpf{margin-bottom:0}";
const _8 = "._2hwxidpf{margin-right:0}";
const _7 = "._19pkidpf{margin-top:0}";
const _6 = "._1e0c1nu9{display:inline}";
const _5 = "._zulppxbi{gap:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodyNormal } from '@atlassian/mpac-primitives';
import React, { useState } from 'react';
import { BulletedPoints } from '../BulletedPoints';
import { Expander } from '../Expander';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._zulpu2gc{gap:var(--ds-space-100,8px)}";
const _3 = "._4cvr1y6m{align-items:flex-start}";
const _2 = "._2lx21bp4{flex-direction:column}";
const _ = "._1e0c1txw{display:flex}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _2lx21bp4 _4cvr1y6m _zulpu2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const ElementWrapper = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = Container,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_zulppxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  ElementWrapper.displayName = 'ElementWrapper';
}
const Label = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = BodyNormal,
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_6, _7, _8, _9, _10]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1nu9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Label.displayName = 'Label';
}
const BoldLabel = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = Label,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_11]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BoldLabel.displayName = 'BoldLabel';
}
export const BulletedPointsList = _ref5 => {
  let {
    bulletedList,
    expandButton
  } = _ref5;
  const [elements, setElements] = useState(null);
  // get the number of elements that needs to be shown
  const renderElements = count => {
    const bulletedPointsListElements = bulletedList.slice(0, count).map((_ref6, index) => {
      let {
        boldLabel,
        label,
        points
      } = _ref6;
      return /*#__PURE__*/_jsxs("div", {
        children: [!!boldLabel && /*#__PURE__*/_jsx(BoldLabel, {
          children: boldLabel
        }), !!label && /*#__PURE__*/_jsx(Label, {
          children: label
        }), /*#__PURE__*/_jsx(BulletedPoints, {
          points: points,
          expandButton: {
            maxCount: bulletedList.length <= expandButton.maxListsCount ? expandButton.maxCount : Number.POSITIVE_INFINITY,
            text: expandButton.text
          }
        })]
      }, index);
    });
    setElements(bulletedPointsListElements);
  };
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(ElementWrapper, {
      children: elements
    }), /*#__PURE__*/_jsx(Expander, {
      text: expandButton.text,
      maxCount: expandButton.maxListsCount,
      totalCount: bulletedList.length,
      onChange: renderElements
    })]
  });
};